// extracted by mini-css-extract-plugin
module.exports = {"root":"LookupPanel_root__3qm3h"};